/**
 * Trophy SVG for final-exam success.
 */
import React from "react";

/**
 * Decorative cup icon used on the success screen.
 */
export default function SvgCup() {

  return <>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 256 256">
      <g transform="translate(128 128) scale(0.72 0.72)">
        <g className="svg-cup-item" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
          <polyline points="51.08,58.19 51.08,72.45 38.92,72.45 38.92,58.19 " className="svg-cup-item fill-main1" transform="  matrix(1 0 0 1 0 0) " />
          <path d="M 72.615 4.465 h 15.411 v 3.427 c 0 19.07 -12.559 42.049 -28.284 42.668 l 4.903 -8.455 c 7.963 -4.503 15.252 -17.734 16.377 -30.785 h -8.407 V 4.465 z" className="svg-cup-item fill-main1" transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
          <path d="M 30.259 50.561 C 14.533 49.941 1.974 26.962 1.974 7.892 V 4.465 h 15.412 v 6.855 H 8.979 c 1.122 13.019 8.379 26.218 16.319 30.753 L 30.259 50.561 z" className="svg-cup-item fill-main1" transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
          <path d="M 61.215 82.276 h -32.43 v -3.6 c 0 -3.438 2.787 -6.224 6.224 -6.224 h 19.982 c 3.438 0 6.224 2.787 6.224 6.224 V 82.276 z" className="svg-cup-item fill-main1" transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
          <path d="M 72.614 1 c 0 32.373 -12.363 58.616 -27.614 58.616 S 17.386 33.373 17.386 1 H 72.614 z" className="svg-cup-item fill-main1" transform=" matrix(1 0 0 1 0 0) " strokeLinecap="round" />
          <polygon points="45,12.92 48.69,20.39 56.93,21.59 50.97,27.4 52.37,35.61 45,31.73 37.63,35.61 39.04,27.4 33.07,21.59 41.31,20.39 " className="svg-cup-item" style={{ fill: '#FFF' }} transform="  matrix(1 0 0 1 0 0) " />
        </g>
      </g>
    </svg>
  </>;
}